import React from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { ViewerComponentProps } from '../types';
import { cn } from '@/common/utils';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

/**
 * PDF Viewer component using @react-pdf-viewer
 * Reuses existing PDF viewing infrastructure
 */
export const PDFViewer: React.FC<ViewerComponentProps> = ({
  fileUrl,
  fileName,
  className,
}) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div className={cn('flex flex-col w-full h-full bg-white', className)}>
      {fileName && (
        <div className="px-4 py-2 border-b bg-gray-50">
          <h3 className="font-semibold text-sm truncate" title={fileName}>
            {fileName}
          </h3>
        </div>
      )}

      <div className="flex-1 overflow-hidden">
        <Viewer
          fileUrl={fileUrl}
          plugins={[defaultLayoutPluginInstance]}
        />
      </div>
    </div>
  );
};

/**
 * Matcher function for registry
 * Returns true if the file is a PDF
 */
export const pdfMatcher = (url: string, fileType: string | null): boolean => {
  return fileType === 'pdf' || url.toLowerCase().endsWith('.pdf');
};
